const state = {
  verificationTry: {
    retriedAfterFaliure: false,
    resent: false,
  },
};

const elements = () => {
  return {
    phoneVerificationModal: document.getElementById("phone_verification_modal"),
    mainPhoneVerifiyButton: document.getElementById("main_phone_verify_button"),
    modalPhoneVerifyButton: document.getElementById(
      "modal_phone_verify_button"
    ),
    otpInput: document.getElementById("otp_input"),
    inProgressPhoneDisplay: document.getElementById(
      "in_progress_phone_display"
    ),
    failurePhoneDisplay: document.getElementById("failure_phone_display"),
    otpSubmitPhoneDisplay: document.getElementById("otp_submit_phone_display"),
    sendingOtpInProgressBox: document.getElementById("sendingOtpInProgressBox"),
    submitOtpBox: document.getElementById("submitOtpBox"),
    numberDontHaveWABox: document.getElementById("numberDontHaveWABox"),
    modalPhoneVerifyRetryButton: document.getElementById(
      "modal_phone_verify_retry_button"
    ),
    modalPhoneVerifyBackButton2: document.getElementById(
      "modal_phone_verify_back_button_2"
    ),
    modalPhoneVerifyBackButton1: document.getElementById(
      "modal_phone_verify_back_button_1"
    ),
    unexpectedErrorBox: document.getElementById("unexpectedErrorBox"),
    exitX: document.getElementById("exit_x"),
    resendTimerText: document.getElementById("resend_timer_text"),
    resendTimer: document.getElementById("resend_timer"),
    resendLink: document.getElementById("resend_link"),
    resendBox: document.getElementById("resend_box"),
    otpSubmitCustomerServiceBox: document.getElementById(
      "otp_submit_customer_service_box"
    ),
    tooManyRequestsErrorBox: document.getElementById("tooManyRequestsErrorBox"),
    hoursRemainingToReset: document.getElementById("hours_remaining_to_rest"),
    minutesRemainingToReset: document.getElementById(
      "minutes_remaining_to_rest"
    ),
    modalPhoneVerifyBackButton3: document.getElementById(
      "modal_phone_verify_back_button_3"
    ),
    verifyButtonText: document.getElementById("verifyButtonText"),
    verifyButtonLoading: document.getElementById("verifyButtonLoading"),
    expiredOTPErrorBox: document.getElementById("expiredOTPErrorBox"),
    modalPhoneVerifyBackButton4: document.getElementById(
      "modal_phone_verify_back_button_4"
    ),
    verifyAttemptsExceededErrorBox: document.getElementById(
      "verifyAttemptsExceededErrorBox"
    ),
    modalPhoneVerifyBackButton5: document.getElementById(
      "modal_phone_verify_back_button_5"
    ),
    verifyErrorMessage: document.getElementById("verifyErrorMessage"),
    backLink: document.getElementById("back_link"),
    remainingHoursText: document.getElementById("remaining_hours_text"),
    changeNameBox: document.getElementById("changeNameBox"),
    exitX2: document.getElementById("exit_x2"),
    changeNameInput: document.getElementById("change_name_input"),
    nameChangeErrorMessage: document.getElementById("nameChangeErrorMessage"),
    nameChangeButton: document.getElementById("name_change_button"),
    nameButtonText: document.getElementById("nameButtonText"),
    nameButtonLoading: document.getElementById("nameButtonLoading"),
  };
};

let previousUrlHash = location.hash;
console.log(previousUrlHash);

/**
 * Splits a full name into firstName and lastName.
 * @param {string} fullName - The full name to split.
 * @returns {{firstName: string, lastName: string}} Object with firstName and lastName.
 */
const splitFullName = (fullName) => {
  const nameParts = fullName.trim().split(/\s+/);
  return {
    firstName: nameParts.shift() || "",
    lastName: nameParts.join(" ") || "-",
  };
};

const startPhoneVerification = async (
  initialStart,
  phoneInput,
  firstName,
  lastName,
  phonePrefix
) => {
  const modalId = "phone-verification-modal";
  if (initialStart) {
    state.verificationTry.retriedAfterFaliure = false;
    state.verificationTry.resent = false;
    if (history.state?.modal === modalId) return;
  }
  let resolveValue = false;
  let exitTimeout;

  return new Promise(async (resolve) => {
    const phone = phonePrefix + phoneInput.substring(1);
    elements().inProgressPhoneDisplay.textContent = phoneInput.replace(
      /^(\d{2})(\d{4})(\d{4})$/,
      "$1 $2 $3"
    );
    elements().failurePhoneDisplay.textContent = phoneInput.replace(
      /^(\d{2})(\d{4})(\d{4})$/,
      "$1 $2 $3"
    );
    elements().otpSubmitPhoneDisplay.textContent = phoneInput.replace(
      /^(\d{2})(\d{4})(\d{4})$/,
      "$1 $2 $3"
    );

    const startTimer = () => {
      elements().resendTimerText.classList.remove("displayNone");
      elements().resendTimer.classList.remove("displayNone");
      elements().resendLink.classList.add("displayNone");
      timeLeft = 30; // Reset timer
      // Clear any existing interval
      if (timerInterval) {
        clearInterval(timerInterval);
      }

      // Update the timer display immediately
      updateTimerDisplay();

      // Start a new interval
      timerInterval = setInterval(() => {
        timeLeft--;
        updateTimerDisplay();

        if (timeLeft <= 0) {
          endTimer();
        }
      }, 1000); // Ticks every 1 second
    };

    const updateTimerDisplay = () => {
      if (timeLeft > 0) {
        // Format time as MM:SS (e.g., 00:30)
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        const formattedTime = `${String(minutes).padStart(2, "0")}:${String(
          seconds
        ).padStart(2, "0")}`;

        elements().resendTimer.textContent = formattedTime;
      }
    };

    const endTimer = () => {
      clearInterval(timerInterval);
      timerInterval = null;
      elements().resendTimerText.classList.add("displayNone");
      elements().resendTimer.classList.add("displayNone");
      elements().resendLink.classList.remove("displayNone");
    };

    const submitOtp = async () => {
      const phone = phonePrefix + phoneInput.substring(1);
      const otp = elements().otpInput.value;
      showVerifyLoading(true);
      const verifyResult = await JodisoAuth.verifyOTP(phone, otp);
      cleanOTPInputAndError();
      showVerifyLoading(false);
      if (verifyResult.success) {
        resolveValue = true;
        if (verifyResult.nameRequired) await startNameChange();
        history.back();
      } else if (
        verifyResult.status == 400 &&
        +verifyResult.data.attemptsLeft > 0
      ) {
        elements().verifyErrorMessage.textContent = `الرمز المدخل خاطئ، تبقى لك عدد ${verifyResult.data.attemptsLeft} من المحاولات`;
      } else if (verifyResult.status == 404) {
        resetDisplayNone();
        elements().expiredOTPErrorBox.classList.remove("displayNone");
      } else {
        resetDisplayNone();
        elements().verifyAttemptsExceededErrorBox.classList.remove(
          "displayNone"
        );
      }
    };
    const showVerifyLoading = (show) => {
      if (show) {
        elements().verifyButtonLoading.classList.remove("displayNone");
        elements().verifyButtonText.classList.add("displayNone");
      } else {
        elements().verifyButtonLoading.classList.add("displayNone");
        elements().verifyButtonText.classList.remove("displayNone");
      }
    };
    const cleanOTPInputAndError = () => {
      elements().otpInput.value = "";
      validateOtpNumber();
      elements().verifyErrorMessage.textContent = "";
    };
    const sanitizeOtpNumber = (inputString) => {
      const arabicNumerals = /[\u0660-\u0669]/g; // Unicode range for Arabic-Indic numerals
      let convertedString = inputString.replace(
        arabicNumerals,
        (d) => d.charCodeAt(0) - 0x0660
      );
      return convertedString.replace(/[^0-9]/g, "");
    };
    const validateOtpNumber = () => {
      const otp = elements().otpInput.value;
      if (otp.length !== 4) {
        elements().modalPhoneVerifyButton.classList.add("disabled");
      } else {
        elements().modalPhoneVerifyButton.classList.remove("disabled");
      }
    };

    const cleanupEventListners = () => {
      elements().resendLink.removeEventListener("click", resendHandler);
      elements().exitX.removeEventListener("click", exitHandler);
      elements().exitX2.removeEventListener("click", exitHandler);
      elements().modalPhoneVerifyButton.removeEventListener("click", submitOtp);
      elements().modalPhoneVerifyRetryButton.removeEventListener(
        "click",
        retryHandler
      );
      elements().modalPhoneVerifyBackButton1.removeEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton2.removeEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton3.removeEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton4.removeEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton5.removeEventListener(
        "click",
        exitHandler
      );
      elements().backLink.removeEventListener("click", exitHandler);
      elements().otpInput.removeEventListener(
        "input",
        sanitizeAndValidateOTPInput
      );
      window.removeEventListener("popstate", popstateHandler);
    };
    const popstateHandler = () => {
      if (previousUrlHash !== "#" + modalId) return;
      console.log(previousUrlHash);
      previousUrlHash = location.hash;
      console.log(previousUrlHash);
      document.body.classList.remove("modal-opened");
      elements().phoneVerificationModal.classList.remove(
        "opened-phoneVerificationModal"
      );
      cleanOTPInputAndError();
      cleanupEventListners();
      clearTimeout(exitTimeout);
      if (timerInterval) clearInterval(timerInterval);
      resolve(resolveValue);
    };
    const exitHandler = () => history.back();
    const resendHandler = async (e) => {
      e?.preventDefault?.();
      state.verificationTry.resent = true;
      cleanOTPInputAndError();
      if (timerInterval) clearInterval(timerInterval);
      cleanupEventListners();
      const result = await startPhoneVerification(
        false,
        phoneInput,
        firstName,
        lastName,
        phonePrefix
      );
      resolve(result);
    };
    const retryHandler = async () => {
      elements().numberDontHaveWABox.classList.add("displayNone");
      state.verificationTry.retriedAfterFaliure = true;
      cleanOTPInputAndError();
      if (timerInterval) clearInterval(timerInterval);
      cleanupEventListners();
      const result = await startPhoneVerification(
        false,
        phoneInput,
        firstName,
        lastName,
        phonePrefix
      );
      resolve(result);
    };
    const sanitizeAndValidateOTPInput = () => {
      elements().otpInput.value = sanitizeOtpNumber(elements().otpInput.value);
      validateOtpNumber();
    };
    const addEventListners = () => {
      elements().resendLink.addEventListener("click", resendHandler);
      elements().exitX.addEventListener("click", exitHandler);
      elements().exitX2.addEventListener("click", exitHandler);
      elements().modalPhoneVerifyButton.addEventListener("click", submitOtp);
      elements().modalPhoneVerifyRetryButton.addEventListener(
        "click",
        retryHandler
      );
      elements().modalPhoneVerifyBackButton1.addEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton2.addEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton3.addEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton4.addEventListener(
        "click",
        exitHandler
      );
      elements().modalPhoneVerifyBackButton5.addEventListener(
        "click",
        exitHandler
      );
      elements().backLink.addEventListener("click", exitHandler);
      elements().otpInput.addEventListener(
        "input",
        sanitizeAndValidateOTPInput
      );
      window.addEventListener("popstate", popstateHandler);
    };
    addEventListners();
    let timerInterval = null;
    let timeLeft = 0;
    resetDisplayNone();
    elements().sendingOtpInProgressBox.classList.remove("displayNone");
    open_phoneVerificationModal(modalId);
    const generateOTP = await JodisoAuth.generateOTP(
      phone,
      firstName,
      lastName
    );
    if (generateOTP.success == true) {
      resetDisplayNone();
      elements().submitOtpBox.classList.remove("displayNone");
      if (state.verificationTry.resent) {
        elements().otpSubmitCustomerServiceBox.classList.remove("displayNone");
        elements().resendBox.classList.add("displayNone");
      } else {
        elements().otpSubmitCustomerServiceBox.classList.add("displayNone");
        elements().resendBox.classList.remove("displayNone");
      }
      exitTimeout = setTimeout(() => {
        elements().exitX.classList.remove("displayNone");
      }, 7000);
      elements().otpInput.focus();
      startTimer();
    } else if (generateOTP.status == 404) {
      if (!state.verificationTry.retriedAfterFaliure) {
        elements().modalPhoneVerifyRetryButton.classList.remove("displayNone");
      } else {
        elements().modalPhoneVerifyRetryButton.classList.add("displayNone");
      }
      resetDisplayNone();
      elements().numberDontHaveWABox.classList.remove("displayNone");
    } else if (generateOTP.status == 429) {
      resetDisplayNone();
      elements().tooManyRequestsErrorBox.classList.remove("displayNone");
      const retryAfter = +generateOTP.data.retryAfter + 60;
      const hours = Math.floor(retryAfter / 3600);
      const minutes = Math.floor((retryAfter / 60) % 60);
      elements().hoursRemainingToReset.textContent = hours;
      if (hours == 0)
        elements().remainingHoursText.classList.add("displayNone");
      elements().minutesRemainingToReset.textContent = minutes;
    } else {
      resetDisplayNone();
      elements().unexpectedErrorBox.classList.remove("displayNone");
    }
  });
};
const startNameChange = async () => {
  let resolveValue = false;
  const modalId = "name-change-modal";
  let exitTimeout;
  if (history.state?.modal === modalId) return;
  return new Promise(async (resolve) => {
    const addEventListners = () => {
      elements().changeNameInput.addEventListener(
        "input",
        validateChangeNameInput
      );
      elements().nameChangeButton.addEventListener("click", nameChangeHandler);
      elements().exitX2.addEventListener("click", exitHandler);
      window.addEventListener("popstate", popstateHandler);
    };
    const cleanupEventListners = () => {
      elements().changeNameInput.removeEventListener(
        "input",
        validateChangeNameInput
      );
      elements().nameChangeButton.removeEventListener(
        "click",
        nameChangeHandler
      );
      elements().exitX2.removeEventListener("click", exitHandler);
      window.removeEventListener("popstate", popstateHandler);
    };
    const nameChangeHandler = async () => {
      elements().nameButtonLoading.classList.remove("displayNone");
      elements().nameButtonText.classList.add("displayNone");

      // Use splitFullName helper to split name into firstName and lastName
      const { firstName, lastName } = splitFullName(
        elements().changeNameInput.value
      );

      const changeNameResult = await JodisoAuth.updateName(firstName, lastName);
      elements().nameButtonLoading.classList.add("displayNone");
      elements().nameButtonText.classList.remove("displayNone");
      if (changeNameResult.success) {
        const firstNameResult = changeNameResult.data.customer.firstName;
        const lastNameResult = changeNameResult.data.customer.lastName;
        const nameResult = {
          firstName: firstNameResult,
          lastName: lastNameResult,
        };
        if (history.state?.modal === modalId) {
          resolveValue = nameResult;
          history.back();
        }
      } else {
      }
    };
    const validateChangeNameInput = () => {
      const name = elements().changeNameInput.value;
      if (name.length <= 2) {
        elements().nameChangeButton.classList.add("disabled");
      } else {
        elements().nameChangeButton.classList.remove("disabled");
      }
    };
    const cleanNameInputAndError = () => {
      elements().changeNameInput.value = "";
      validateChangeNameInput();
      elements().nameChangeErrorMessage.textContent = "";
    };

    const popstateHandler = () => {
      if (previousUrlHash !== "#" + modalId) return;
      console.log(previousUrlHash);
      previousUrlHash = location.hash;
      console.log(previousUrlHash);
      document.body.classList.remove("modal-opened");
      elements().phoneVerificationModal.classList.remove(
        "opened-phoneVerificationModal"
      );
      cleanNameInputAndError();
      cleanupEventListners();
      clearTimeout(exitTimeout);
      resolve(resolveValue);
    };
    const exitHandler = () => history.back();
    addEventListners();
    resetDisplayNone();
    elements().changeNameBox.classList.remove("displayNone");
    open_phoneVerificationModal(modalId);
    exitTimeout = setTimeout(() => {
      elements().exitX2.classList.remove("displayNone");
    }, 7000);
    elements().changeNameInput.focus();
  });
};

const open_phoneVerificationModal = (modalId) => {
  if (history.state?.modal === modalId) return;
  history.pushState({ modal: modalId }, null, "#" + modalId);
  previousUrlHash = "#" + modalId;
  console.log(previousUrlHash);

  elements().phoneVerificationModal.classList.add(
    "opened-phoneVerificationModal"
  );
  document.body.classList.add("modal-opened");
};
const resetDisplayNone = () => {
  const elementsToBeReseted = document.querySelectorAll(
    ".displayNoneToBeResetted"
  );
  for (const element of elementsToBeReseted) {
    element.classList.add("displayNone");
  }
};
